import { Identifiable, Project, ProjectResource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeResourceFromProject(httpClient: HttpClient) {
  return (
    project: Identifiable<Project>,
    projectResource: Identifiable<ProjectResource>,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/${project.uuid}/delete-resource-project`,
        method: HttpMethods.DELETE,
        data: {
          source: projectResource.uuid,
        },
      })
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { removeResourceFromProject };
